

<template>
	<div class="cf">
		<van-uploader :upload-icon=" roots + '/static/x0.png'" :upload-text="title" :after-read="selectImage" :before-delete='befdel' deletable  v-model="fileList"  multiple :max-count="max?max:1" />
	</div>
</template>

<script>
	export default {
		name:'up-load',
		props:['upload','index','fileList_s','max','title'],
		data(){
			return {
				fileList:[]
			}
		},
		created(){
			
		},
		methods:{
			befdel(a,b){//删除图片
				console.log(a,b);
				var $th=this;
				$th.fileList.splice(b.index,1);
				$th.upload({path:0,img:0,del:1},$th.index,b.index);
			},
			afterRead(file) { //图片上传
				var $th=this;
			var param = new FormData();
			console.log(file);
			param.append("file", file.file);
				$th.$File(
					"/imgController/catImgUpload",
					param,
					function(reqData) {
						console.log("文件上传结果",reqData)
						if (reqData.code == 200) {
							$th.upload({path:reqData.data,img:file.content,del:0},$th.index);
							$th.$toast('文件上传成功');
						}else{
							
						}
					}
				);
			//获取图片回调
			},
			selectImage(files,callbak) {
				files.status = 'uploading';
				files.message = '上传中...';
						var that = this;
						var file = files.file;
						if (file.size >= 5242895) {
							that.$dialog.alert({
                            title: '提示',
                            message: '请上传5M以内的图片!',
                            })
                            .then(() => {
								files.status = 'failed';
								files.message = '上传失败';
								that.fileList.splice(0,1);
							});
							return false;
						}
						var regrule = new RegExp("gif|jpg|jpeg|png|pngs/gi");
						if (!regrule.test(file.type)) {
							that.$dialog.alert({
                            title: '提示',
                            message: '您上传的图片格式不正确请您重新选择!',
                            })
                            .then(() => {
								files.status = 'failed';
								files.message = '上传失败';
								that.fileList.splice(0,1);
							});
							return false;
						}
						var reader = new FileReader();
				        reader.onload = function(evt){
				        	that.up(evt.target.result,function(reqdata){
								console.log(reqdata)
								that.upload({path:reqdata.data,img:file.content,del:0},that.index);
								that.$toast('文件上传成功');
								files.status = '';
								files.message = '';
							},function(){
								files.status = 'failed';
								files.message = '上传失败';
								that.fileList.splice(0,1);
							});
				        }
				        reader.readAsDataURL(file);
					},
			up(postData,callbak,errbak){
				var that=this;
			
				$.ajax({
					type: "post",
					url: posturl_cart+'AwsUpload/aws',
					dataType:'json',
					data: {'img':postData},
					success: function(res) { 
						console.log(res);
						var reqData = res;
						if(reqData.err_code=='000'){
							callbak(reqData);
						}else{
							that.$dialog.alert({
                            title: '提示',
                            message: '图片上传失败!',
                            })
                            .then(() => {
							});
							errbak();
						}
					},
					error: function(res){
					
						errbak();
						that.$dialog.alert({
                            title: '提示',
                            message: '服务器异常!',
                            })
                            .then(() => {
                        });
						
					}
				});
				
			  }
   
   
		},
		computed:{
			sum:function(){
				console.log(this.fileList_s);
              return this.fileList_s
            },
		},
		watch: {
			fileList_s: function (val) {
				console.log(val);
				
				if(0){//添加默认
					if(val instanceof Array){
						var a=[]
						$.each(val,function(i,v){
							a.push({url:v});
						})
						console.log(a);
						this.fileList=a
					}else{
						this.fileList=[{ url: val }]
					}
				}
           }
  }
	}
</script>


<style  scoped="scoped">

</style>



// WEBPACK FOOTER //
// src/components/global/updata/index.vue